module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.itemType, {
    tag: "a",
    class: ['dropdown-item', {
      disabled: _vm.disabled
    }],
    attrs: {
      "to": _vm.to,
      "disabled": _vm.disabled,
      "tabindex": "-1",
      "role": "menuitem"
    },
    on: {
      "click": _vm.click
    },
    nativeOn: {
      "click": function($event) {
        _vm.click($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39258500"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/dropdown-item.vue
// module id = 234
// module chunks = 0